<template>
  <div class="domains-wrp">
    <TrackingRoot />
    <TrackingDomains />
  </div>
</template>

<script setup lang="ts">
import { useStore } from '@/store';
import { onMounted } from 'vue';
import TrackingRoot from './tracking/root.vue';
import TrackingDomains from './tracking/tracking-domains.vue';
import { populateTrackingDomainsStoreCacheApiRequest } from '@/services/api/api-services/domains';

const store = useStore();
onMounted(async () => {
  if (!store.trackingDomains.isUploaded) {
    await populateTrackingDomainsStoreCacheApiRequest();
  }
});
</script>
<style lang="scss" scoped>
.domains-wrp {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
</style>
